import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { id: "legend" }
const _hoisted_2 = { class: "container mx-auto my-8 flex flex-col gap-5 w-full md:w-6/12" }
const _hoisted_3 = {
  id: "filters",
  class: "grid grid-cols-12 items-center gap-3"
}
const _hoisted_4 = { class: "col-span-12" }
const _hoisted_5 = { class: "p-input-icon-right w-full" }
const _hoisted_6 = {
  key: 0,
  class: "col-span-12"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = {
  key: 1,
  id: "content"
}
const _hoisted_9 = {
  key: 0,
  class: "my-5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Card = _resolveComponent("Card")!
  const _component_EmptyData = _resolveComponent("EmptyData")!
  const _component_FullModal = _resolveComponent("FullModal")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_FullModal, {
      headerInfo: _ctx.headerInfo,
      onOnClose: _ctx.onCloseCrawler,
      hasIcon: true
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h4", null, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: "Buscar por vídeos",
                  en: "Search for videos",
                })), 1),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", _hoisted_5, [
                  (!_ctx.search.submited)
                    ? (_openBlock(), _createElementBlock("i", {
                        key: 0,
                        class: "pi pi-search cursor-pointer",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSearch()))
                      }))
                    : (_openBlock(), _createElementBlock("i", {
                        key: 1,
                        class: "pi pi-times cursor-pointer",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSearch('clear')))
                      })),
                  _createVNode(_component_InputText, {
                    modelValue: _ctx.search.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search.value) = $event)),
                    placeholder: _ctx.$t('crawler.placeholder'),
                    class: "w-full",
                    onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.onSearch()), ["enter"]))
                  }, null, 8, ["modelValue", "placeholder"])
                ])
              ]),
              (_ctx.search.submited)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("p", {
                      innerHTML: 
                    _ctx.$t('labels.generic', {
                      pt: `Você pesquisou por “<b>${_ctx.search.submited}</b>”, esses foram os resultados encontrados:`,
                      en: `You searched for “<b>${_ctx.search.submited}</b>”, these were the results found:`,
                    })
                  
                    }, null, 8, _hoisted_7)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.loading)
              ? (_openBlock(), _createBlock(_component_Loader, {
                  key: 0,
                  loader: _ctx.loading,
                  loaderSize: "h-96"
                }, null, 8, ["loader"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (_ctx.data.length !== 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createVNode(_component_Card, { data: _ctx.data }, null, 8, ["data"])
                      ]))
                    : (_openBlock(), _createBlock(_component_EmptyData, {
                        key: 1,
                        data: !_ctx.data || _ctx.data.length == 0,
                        title: _ctx.emptyState.title,
                        label: _ctx.emptyState.description,
                        image: _ctx.emptyState.image,
                        imgSize: "h-52 my-10",
                        msgSize: "md:w-8/12"
                      }, null, 8, ["data", "title", "label", "image"]))
                ]))
          ])
        ])
      ]),
      _: 1
    }, 8, ["headerInfo", "onOnClose"])
  ]))
}